import { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../utils/const/estilos-const";
import ModalConfirmar from "../../components/modal-confirmar";
import "../../style/style-cargando.css";
import cargandoCard from "../../components/cargando-card";
import sinAccesoCard from "../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedMensajeConfirmacion, } from "../../utils/shared-functions";
// import { SELECT_HABILITADO_DESHABILITADO } from "../../utils/const/const-select-habilitado-deshabilitado";
// import Select from "react-select";
// import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
// import { COLOR_VERDE_MAIN } from "../../utils/const/colors-const";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import Calendar from "../../components/calendar";
import moment from "moment";
import { deshabilitarDetallePedido, deshabilitarPedido, obtenerListaDetallePedido, obtenerListaPedido } from "../../api/api-pedido";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";


let $ = window.$;

export default function AsignacionPage
    () {
    const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
    const { t } = useTranslation();
    // const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [listaElementos, setListaElementos] = useState([]);
    const [modalConfirmarDeshabilitarDetallePedido, setModalConfirmarDeshabilitarDetallePedido] = useState(false);
    const [modalConfirmarDeshabilitarPedido, setModalConfirmarDeshabilitarPedido] = useState(false);
    const [detallePedidoSelected, setDetallePedidoSelected] = useState(null);
    const [pedidoSelected, setPedidoSelected] = useState(null);
    // const [permisos, setPermisos] = useState(null);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);

    const [fechaSelected, setFechaSelected] = useState(moment().format("YYYY-MM-DD"));

    const [rowsDataPedido, setRowsDataPedido] = useState([]);
    const [rowsDataDetallePedido, setRowsDataDetallePedido] = useState([]);

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

    const [btnBuscar, setBtnBuscar] = useState(false);
    const [btnEliminarPedido, setBtnEliminarPedido] = useState(false);
    const [btnDetallesPedido, setBtnDetallesPedido] = useState(false);
    const [btnEliminarDetallePedido, setBtnEliminarDetallePedido] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        let tieneAcceso = false;
        try {
            let objEnviar = {};
            objEnviar.fechaEntrega = moment().format("YYYY-MM-DD");
            if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
                tieneAcceso = true;
                setBtnBuscar(true);
                setBtnEliminarPedido(true);
                setBtnDetallesPedido(true);
                setBtnEliminarDetallePedido(true);
            }
            if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
                const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
                objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
                const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
                if (response.error === false && response.data !== undefined) {
                    const permisos = JSON.parse(response.data.permisos);
                    // console.log('permisos');
                    // console.log(permisos);
                    if (Array.isArray(permisos) && permisos.length > 0) {
                        const manage = permisos.find(p => p.id === 5);
                        if (manage !== undefined && manage !== null) {
                            const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.ASIGNACION);
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            tieneAcceso = permisosPage.checked;
                            if (tieneAcceso === false) {
                                return;
                            }
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
                            const permisoBtnEliminarPedido = permisosPage.acciones.find(a => a.value === 'btn_eliminar_pedido');
                            const permisoBtnDetallesPedido = permisosPage.acciones.find(a => a.value === 'btn_detalles_pedido');
                            const permisoBtnEliminarDetallePedido = permisosPage.acciones.find(a => a.value === 'btn_eliminar_detalle_pedido');
                            setBtnBuscar(permisoBtnBuscar?.checked);
                            setBtnEliminarPedido(permisoBtnEliminarPedido?.checked);
                            setBtnDetallesPedido(permisoBtnDetallesPedido?.checked);
                            setBtnEliminarDetallePedido(permisoBtnEliminarDetallePedido?.checked);
                        }
                    }
                }
            }
            if (tieneAcceso === true) {
                let lista = [];

                lista = await obtenerListaPedido(objEnviar);
                setRowsDataPedido(lista);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        } finally {
            setCargandoPage(false);
            setTieneAccesoAlModulo(tieneAcceso);
        }
    };

    useEffect(() => {
        // Small delay to ensure DOM is ready
        const timer = setTimeout(() => {
            const gridElementAsignacion = $("#gridContainerAsignacion");
            if (gridElementAsignacion.length) {
                try {
                    const gridInstance = gridElementAsignacion.dxDataGrid("instance");
                    if (gridInstance) {
                        // Grid already exists, just update the data source
                        gridInstance.option("dataSource", rowsDataPedido);
                    } else {
                        // Grid doesn't exist yet, initialize it
                        inicializarGridAsignacion();
                    }
                } catch (e) {
                    // Grid doesn't exist yet, initialize it
                    inicializarGridAsignacion();
                }
            }

            const gridElementDetalleAsignacion = $("#gridContainerDetalleAsignacion");
            if (gridElementDetalleAsignacion.length) {
                try {
                    const gridInstance = gridElementDetalleAsignacion.dxDataGrid("instance");
                    if (gridInstance) {
                        // Grid already exists, just update the data source
                        gridInstance.option("dataSource", rowsDataDetallePedido);
                    } else {
                        // Grid doesn't exist yet, initialize it
                        inicializarGridDetalleAsignacion();
                    }
                } catch (e) {
                    // Grid doesn't exist yet, initialize it
                    inicializarGridDetalleAsignacion();
                }
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [rowsDataPedido, rowsDataDetallePedido]);

    const inicializarGridAsignacion = () => {
        try {
            const gridElementAsignacion = $("#gridContainerAsignacion");

            // Check if element exists
            if (!gridElementAsignacion.length) {
                // console.warn("Grid container element not found");
                return;
            }

            // Initialize the grid
            gridElementAsignacion.dxDataGrid({
                dataSource: rowsDataPedido,
                paging: {
                    pageSize: 20,
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [50, 100, 150, 200],
                },
                remoteOperations: false,
                groupPanel: { visible: true },
                grouping: {
                    autoExpandAll: false,
                },
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                showBorders: true,
                columnAutoWidth: true,
                filterRow: {
                    visible: true,
                    applyFilter: "auto",
                },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: t("grilla_placeholderbuscar"),
                },
                export: {
                    enabled: true,
                },
                headerFilter: {
                    visible: true,
                },
                columns: [
                    {
                        dataField: "acciones",
                        caption: t("column_acciones"),
                        width: 200,
                        allowFiltering: false,
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            // console.log("cellTemplate acciones");
                            // console.log('options', options);
                            // console.log('options.data', options.data);
                            const buttonContainer = $("<div>").addClass("flex gap-2");
                            if (btnEliminarPedido === true) {
                                $("<button>")
                                    .addClass(
                                        "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                                    )
                                    .text(t("column_eliminar"))
                                    .on("click", function () {
                                        handleEliminarPedido(options.data);
                                    })
                                    .appendTo(buttonContainer);
                            }
                            if (btnDetallesPedido === true) {
                                // Edit button
                                $("<button>")
                                    .addClass(
                                        "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                                    )
                                    .text(t("column_detalles"))
                                    .on("click", function () {
                                        btnVerDetallePedido(options.data);
                                    })
                                    .appendTo(buttonContainer);
                            }


                            buttonContainer.appendTo(container);
                        },
                    },
                    {
                        dataField: "id",
                        caption: "ID",
                        visible: false,
                    },
                    // {
                    //     dataField: "fechaEntrega",
                    //     caption: t("column_fecha_entrega"),
                    //     visible: true,
                    // },
                    {
                        dataField: "valuePlaca",
                        caption: t("column_placa"),
                        visible: false,
                    },
                    {
                        dataField: "labelPlaca",
                        caption: t("column_placa"),
                        visible: true,
                        width: 150,
                    },
                ],
            });
        } catch (err) {
            console.error("Error initializing grid:", err);
        }
    };

    const inicializarGridDetalleAsignacion = () => {
        try {
            const gridElementDetalleAsignacion = $("#gridContainerDetalleAsignacion");

            // Check if element exists
            if (!gridElementDetalleAsignacion.length) {
                // console.warn("Grid container element not found");
                return;
            }

            // Initialize the grid
            gridElementDetalleAsignacion.dxDataGrid({
                dataSource: rowsDataDetallePedido,
                paging: {
                    pageSize: 20,
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [50, 100, 150, 200],
                },
                remoteOperations: false,
                groupPanel: { visible: true },
                grouping: {
                    autoExpandAll: false,
                },
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                showBorders: true,
                columnAutoWidth: true,
                filterRow: {
                    visible: true,
                    applyFilter: "auto",
                },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: t("grilla_placeholderbuscar"),
                },
                export: {
                    enabled: true,
                },
                headerFilter: {
                    visible: true,
                },
                columns: [
                    {
                        dataField: "acciones",
                        caption: t("column_acciones"),
                        width: 200,
                        allowFiltering: false,
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            // console.log("cellTemplate acciones");
                            // console.log('options', options);
                            // console.log('options.data', options.data);
                            const buttonContainer = $("<div>").addClass("flex gap-2");
                            if (btnEliminarDetallePedido === true) {
                                $("<button>")
                                    .addClass(
                                        "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                                    )
                                    .text(t("column_eliminar"))
                                    .on("click", function () {
                                        handleEliminarDetallePedido(options.data);
                                    })
                                    .appendTo(buttonContainer);

                            }
                            buttonContainer.appendTo(container);
                        },
                    },
                    {
                        dataField: "idDetallePedido",
                        caption: "ID Detalle Pedido",
                        visible: false,
                    },
                    {
                        dataField: "idPedido",
                        caption: "ID Pedido",
                        visible: false,
                    },
                    {
                        dataField: "valuePlaca",
                        caption: t("column_placa"),
                        visible: false,
                    },
                    {
                        dataField: "labelPlaca",
                        caption: t("column_placa"),
                        width: 150,
                        visible: true,
                    },
                    {
                        dataField: "idCliente",
                        caption: "ID Cliente",
                        // width: 200,
                        visible: false,
                    },
                    {
                        dataField: "cliente",
                        caption: t("column_cliente"),
                        width: 200,
                        visible: true,
                    },
                    {
                        dataField: "numeroDocumento",
                        caption: t("column_numero_documento"),
                        width: 200,
                        visible: true,
                    },
                ],
            });
        } catch (err) {
            console.error("Error initializing grid:", err);
        }
    };

    const btnVerDetallePedido = async (data) => {
        try {
            // console.log("btnVerDetallePedido");
            // console.log(data);
            setPedidoSelected(data);
            setDetallePedidoSelected(null);
            setRowsDataDetallePedido([]);
            setProcessingVisible(true);
            let objEnviar = {};
            objEnviar.idPedido = data.id;
            const lista = await obtenerListaDetallePedido(objEnviar);
            setRowsDataDetallePedido(lista);
            setProcessingVisible(false);
        } catch (err) {
            console.log("btnVerDetallePedido err");
            console.log(err);
            setProcessingVisible(false);
        }
    };

    const handleEliminarPedido = async (data) => {
        try {
            // console.log("handleEliminarPedido");
            // console.log(data);
            setPedidoSelected(data);
            setModalConfirmarDeshabilitarPedido(true);
        } catch (err) {
            console.log("handleEliminarPedido err");
            console.log(err);
        }
    };

    const handleEliminarDetallePedido = async (data) => {
        try {
            console.log("handleEliminarDetallePedido");
            console.log(data);
            setDetallePedidoSelected(data);
            setModalConfirmarDeshabilitarDetallePedido(true);
        } catch (err) {
            console.log("handleEliminarDetallePedido err");
            console.log(err);
        }
    };

    const buscarPedido = async () => {
        try {
            setProcessingVisible(true);
            setRowsDataDetallePedido([]);
            setRowsDataPedido([]);
            let objEnviar = {};
            objEnviar.fechaEntrega = fechaSelected;
            const lista = await obtenerListaPedido(objEnviar);
            setRowsDataPedido(lista);
            setProcessingVisible(false);
        } catch (err) {
            console.log("buscarPedido err");
            console.log(err);
            setProcessingVisible(false);
        }
    };

    const showToast = (message, type = "warning", durationMs = 3000) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
        }, durationMs);
    };

    const handleConfirmModalDeshabilitarDetallePedido = async () => {
        setModalConfirmarDeshabilitarDetallePedido(false);
        if (detallePedidoSelected == null) {
            return;
        }
        // console.log('pedidoSelected');
        // console.log(pedidoSelected);
        // console.log('detallePedidoSelected');
        // console.log(detallePedidoSelected);
        let objEnviar = {};
        objEnviar.idDetallePedido = detallePedidoSelected.idDetallePedido;
        objEnviar.numeroDocumento = detallePedidoSelected.numeroDocumento;
        setProcessingVisible(true);
        const response = await deshabilitarDetallePedido(objEnviar);
        setProcessingVisible(false);
        if (response.error === false) {
            showToast(t("alert_se_deshabilito_correctamente"));
            setRowsDataDetallePedido(rowsDataDetallePedido.filter(item => item.idDetallePedido !== detallePedidoSelected.idDetallePedido));
        }
        if (response.error === true) {
            showToast(response.message, "error", 3000);
        }
    };

    const handleConfirmDeshabilitarPedido = async () => {
        setModalConfirmarDeshabilitarPedido(false);
        if (pedidoSelected == null) {
            return;
        }
        let objEnviar = {};
        objEnviar.idPedido = pedidoSelected.id;
        setProcessingVisible(true);
        const response = await deshabilitarPedido(objEnviar);
        setProcessingVisible(false);
        if (response.error === false) {
            showToast(t("alert_se_deshabilito_correctamente"));
            setDetallePedidoSelected(null);
            setRowsDataDetallePedido([]);
            setRowsDataPedido(rowsDataPedido.filter(item => item.id !== pedidoSelected.id));
        }
        if (response.error === true) {
            showToast(response.message, "error", 3000);
        }
    };

    const render = () => {
        try {
            // console.log('listar correo render');
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return sinAccesoCard();
            }
            return (
                <div className="max-w-7xl mx-auto px-4 lg:px-6">
                    <div className="flex items-center justify-between py-4">
                        <div>
                            <div className="flex items-center gap-2">
                                <h2 className="text-xl font-bold text-gray-900">{t("label_asignacion")}</h2>
                            </div>
                            <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_asignacion")}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            {/* <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_NUEVO}
                                onClick={() => {
                                    handleNuevoClick();
                                }}
                            >
                                {t("label_nuevo")}
                            </button> */}
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                                {t("label_fecha")}
                            </label>
                            <Calendar
                                value={fechaSelected}
                                onChange={(date) => setFechaSelected(date)}
                                placeholder={t("placeholder_seleccione_fecha")}
                                id="fecha_asignacion"
                                name="fecha_asignacion"
                            />
                        </div>
                        {btnBuscar === true && (
                            <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                                    &nbsp;
                                </label>
                                <button
                                    type="button"
                                    className={ESTILO_BOTON_MODAL_ACEPTAR}
                                    onClick={() => { buscarPedido(); }}
                                >
                                    {t("label_buscar")}
                                </button>
                            </div>
                        )}
                    </div>
                    <br />
                    {/* Grid Card */}
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            <div className="min-h-[400px]">
                                <div
                                    id="gridContainerAsignacion"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-8 xl:col-span-8">
                            <div className="min-h-[400px]">
                                <div
                                    id="gridContainerDetalleAsignacion"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <ModalConfirmar
                        isOpen={modalConfirmarDeshabilitarDetallePedido}
                        onCancel={() => { setModalConfirmarDeshabilitarDetallePedido(false); }}
                        onConfirm={handleConfirmModalDeshabilitarDetallePedido}
                        message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), detallePedidoSelected?.cliente)}
                    />
                    <ModalConfirmar
                        isOpen={modalConfirmarDeshabilitarPedido}
                        onCancel={() => { setModalConfirmarDeshabilitarPedido(false); }}
                        onConfirm={handleConfirmDeshabilitarPedido}
                        message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), pedidoSelected?.valuePlaca)}
                    />
                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                </div>
            );
        } catch (err) {
            console.log('ListarPais render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    }

    return render();
}
